import * as React from "react";
import PropTypes from "prop-types";

import Button from '@p1s/p1s-common-react/Button';
import Modal from "react-bootstrap/lib/Modal";

class ModalDialog extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        var buttons = this.props.buttons.map((item, i) => (<Button bsStyle={item.bsStyle} className={item.cssClass} onClick={item.onClick} key={item.key}
            id={item.key}>{item.text}</Button>));

        return (
            <Modal {...this.props} show={this.props.show} onHide={this.props.onDocumentClose}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.content}
                </Modal.Body>
                <Modal.Footer>
                    {buttons}
                </Modal.Footer>
            </Modal>
        );
    }
}

ModalDialog.propTypes = {
    onDocumentClose: PropTypes.func
};

export default ModalDialog;
